export class ReferenceKeyHelper {
  static getId(name, references) {
    const reference = references.find(x => x.name === name && x.referenceId !== null);
    if (reference) {
      return reference.referenceId;
    }
    return undefined;
  }
}